import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import Sidebar from '../JobCardView/Sidebar';
import JobApply from './Form';

const ApplyContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Apply' parent='Job Search' title='Apply' />
      <Row>
        <Sidebar />
        <JobApply />
      </Row>
    </Container>
  );
};

export default ApplyContainer;
